define.alias("ember-cli-string-helpers/helpers/titleize", "media/helpers/titleize");